import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import ProjectManagerList from "./ProjectManagerList"

const ProjectManager = () => {
      const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

  return (
    <div>
        
        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<ProjectManagerList/>}
                menuId={9}
            />
        </DataContext.Provider>
    </div>
  )
}

export default ProjectManager